import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { connect, useDispatch } from 'react-redux'
import { getRequest } from '../../globalhelper/helper'
import '../CI/COD.css'
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer'
import _ from 'lodash'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { navUrl } from '../../redux/Common/commonActions'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment/moment'
import { CSVLink } from 'react-csv'
import { GetApp } from '@material-ui/icons'

const ExtendVendorMaster = props => {
  const [showtable, setShowtable] = useState(false)
  const [formData, setFormData] = useState({
    vendorname: '',
    vendorid: '',
    vendortype: '',
    status: '',
    orgname: '',
    state: '',
    period: null
  })
  let disaptch = useDispatch()
  const [tableData, setTableData] = useState([])
  const [filteredTableData, setFilteredTableData] = useState([])
  const [dropdown_vendorname, setDropdownVendorname] = useState([])
  const [dropdown_vendorid, setDropdownVendorid] = useState([])
  const [dropdown_vendortype, setDropdownVendortype] = useState([])
  const [extendJSON, setExtendJSON] = useState([])
  const [dropdown_orgname, setDropdownOrgname] = useState([])
  const [companyDetails, setCompanyDetails] = useState([])
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [createJSON, setCreateJSON] = useState([])
  const [redirect, setRedirect] = useState(false)
  const [SearchJSON, setSearchJSON] = useState([])

  useEffect(() => {
    sessionStorage.setItem('pageName', 'Search Vendor Preferences')

    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(response => {
        console.log(response.res.data)
        const responseData = _.sortBy(response.res.data, 'orgname')
        const arr = responseData
          .map(item => item.orgname)
          ?.sort((a, b) => a.localeCompare(b))
        console.log(arr)
        if (arr?.length === 1) {
          handleChange('orgname', arr[0])
        }
        setDropdownOrgname(arr)
        setCompanyDetails(responseData)
      })
      .catch(err => console.log(err))

    getRequest(`api/edureka/getVendorJSONForExtension`).then(res => {
      console.log(res.res.data)
      setExtendJSON(res.res.data)
      setCreateJSON(res.res.data)
    })

    getRequest(`api/edureka/getVM1`).then(res => {
      if (res.res.status === 'success') {
        let temp = JSON.parse(res.res.data)
        console.log(temp)
        let temp1 = temp.map(value => value['Vendor Name'])
        let vendorname = [...new Set(temp1)].sort((a, b) => a.localeCompare(b))
        console.log(vendorname)
        let temp3 = temp.map(value => value['Vendor Type'])
        let tem = temp3.filter(value => value)
        let vendortype = [...new Set(tem)].sort((a, b) => a.localeCompare(b))

        let vid1 = temp.map(value => value['Vendor ID'])
        let vid2 = [...new Set(vid1)].sort((a, b) => a.localeCompare(b))

        setDropdownVendorname(vendorname)
        setDropdownVendorid(vid2)
        setDropdownVendortype(vendortype)
      } else {
        console.log('No Data')
      }
    })
  }, [])

  useEffect(() => {
    if (!formData.period) return

    // if your period is '2025-10'
    const startDate = moment(formData.period, 'YYYY-MM').startOf('month')
    const endDate = moment(formData.period, 'YYYY-MM').endOf('month')

    const filtered = tableData.filter(item => {
      // parse with correct format (DD/MM/YYYY)
      const itemDate = moment(
        item?.['Created At'],
        ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD', 'DD/MM/YYYY'],
        true
      )
      console.log(
        itemDate,
        startDate,
        endDate,
        itemDate.isSameOrAfter(startDate),
        itemDate.isSameOrBefore(endDate),
        formData.state,
        formData.state === 'ALREADY EXTENDED',
        item['Preferences item ID'],
        formData.state === 'EXTEND' &&
        !item['Preferences item ID'] &&
        itemDate.isSameOrAfter(startDate) &&
        itemDate.isSameOrBefore(endDate),
        formData.state === 'ALREADY EXTENDED' &&
        item['Preferences item ID'] &&
        itemDate.isSameOrAfter(startDate) &&
        itemDate.isSameOrBefore(endDate),
        formData.state === '' &&
        itemDate.isSameOrAfter(startDate) &&
        itemDate.isSameOrBefore(endDate),
        false
      )
      return (
        (formData.state === 'EXTEND' &&
          !item['Preferences Vendor ID'] &&
          itemDate.isSameOrAfter(startDate) &&
          itemDate.isSameOrBefore(endDate)) ||
        ((formData.state === '' ||
          formData.state === null ||
          formData.state === undefined) &&
          itemDate.isSameOrAfter(startDate) &&
          itemDate.isSameOrBefore(endDate)) ||
        false
      )
    })
    console.log(filtered)

    setFilteredTableData(filtered)
  }, [formData.period, formData.state])

  const handleChange = (name, value) => {
    if ((name === 'state' || name === 'period') && value) {
    }
    setFormData(prev => ({
      ...prev,
      [name]: value || ''
    }))
  }

  const handleVendor = i => {
    console.log(i)
    const vendorid = i['Vendor ID']

    getRequest(`api/edureka/getVMUpdatedJSON?vendorid=${vendorid}`).then(
      res => {
        if (res.res.status === 'success') {
          console.log(res.res.data)
          const data =
            typeof res.res.data === 'string'
              ? JSON.parse(res.res.data)
              : res.res.data
          setSearchJSON(data)
          if (data.length) {
            setRedirect(true)
          }
        } else {
          console.log('No Data')
        }
      }
    )
  }

  const handleSearch = () => {
    const { orgname } = formData

    if (orgname) {
      setError(false)

      const vendorname = formData.vendorname
      const vendortype = formData.vendortype
      const vendorid = formData.vendorid

      const id = companyDetails.filter(
        item => item.orgname === formData.orgname
      )

      console.log(id)

      const companyid = id.map(item => item.orgid)

      console.log(companyid)

      getRequest(
        `api/edureka/getExtendVendorMasterData?vendorname=${vendorname}&vendortype=${vendortype}&vendorid=${vendorid}&orgid=${companyid[0]}`
      ).then(res => {
        if (res.res.status === 'success') {
          let temp = JSON.parse(res.res.data)
          console.log(temp)
          setFilteredTableData(temp)
          setTableData(temp)
          setShowtable(true)
        } else {
          console.log('No Data')
        }
      })
    } else {
      setError(true)
      setErrorMessage('Please select all the required fields')
    }
  }

  const handleReset = () => {
    setShowtable(false)
    setError(false)
    setFormData({
      vendorname: '',
      vendorid: '',
      vendortype: '',
      status: '',
      orgname: '',
      period: null
    })
  }

  const onBack = () => {
    setRedirect(false)
    setSearchJSON([])
  }

  const handleExtend = item => {
    const vendorID = item['Vendor ID']
    const vendorName = item['Vendor Name']

    const id = companyDetails.filter(item => item.orgname === formData.orgname)

    console.log(id)

    const companyid = id.map(item => item.orgid)

    console.log(companyid)

    console.log(vendorID, vendorName)

    const vendorNameIndex = extendJSON[1].children[0].children.findIndex(
      item => item.title === 'Vendor Name'
    )

    const orgNameIndex = extendJSON[1].children[0].children.findIndex(
      item => item.title === 'Organization Name'
    )

    const vendorIDIndex = extendJSON[1].children[0].children.findIndex(
      item => item.title === 'Vendor ID'
    )

    const orgIDIndex = extendJSON[1].children[0].children.findIndex(
      item => item.title === 'Organization ID'
    )

    const updatedJSONData = [...createJSON]

    updatedJSONData[1].children[0].children[vendorNameIndex].val = vendorName
    updatedJSONData[1].children[0].children[vendorNameIndex].editable = 'false'
    updatedJSONData[1].children[0].children[vendorIDIndex].val = vendorID
    updatedJSONData[1].children[0].children[orgNameIndex].val = formData.orgname
    updatedJSONData[1].children[0].children[orgIDIndex].val = companyid[0]

    setExtendJSON(updatedJSONData)
    setRedirect(true)
    console.log(updatedJSONData)
  }

  const handleScreenRouting = item => {
    console.log(item)
    const orgID = item['Org ID']
    const preferredID = item['Preferences Vendor ID']
    localStorage.setItem('api', `api/edureka/getExtendJSONForVendorPreference?lde1=${orgID}&lde2=${preferredID}`);
    // localStorage.setItem('apiParams', JSON.stringify({
    //   "LDE": {
    //     "Organization ID": orgID,
    //     "Vendor ID": preferredID,
    //   },
    //   "Module": localStorage.getItem('module'),
    //   "screenName": "VendorPreferences"
    // }))
    window.open(
      `/Dynamic_Forms?token=VendorPreferences&action=edit&orgId=${orgID}&docId=${preferredID}`,
      '_blank'
    )
    // getRequest(
    //   `api/edureka/getExtendJSONForVendorPreference?lde1=${orgID}&lde2=${preferredID}`
    // )
    //   .then(response => {
    //     setExtendJSON(response.res.data)
    //     setRedirect(true)
    //     console.log(response.res.data)
    //   })
    //   .catch(err => console.log(err))
  }

  if (redirect) {
    return (
      <VR2_Forms
        screenName={'VendorPreferences'}
        screenAction={'edit'}
        From_SearchJSON={extendJSON}
        onBack={onBack}
      />
    )
  }

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel3-content'
          id='panel3-header'
        >
          <Typography variant='h6'>Search Vendor Preferences</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete
                options={dropdown_orgname}
                value={
                  dropdown_orgname.find(
                    option => option === formData.orgname
                  ) || ''
                }
                onChange={(e, newValue) => handleChange('orgname', newValue)}
                renderInput={params => (
                  <TextField
                    name='orgname'
                    {...params}
                    label='Organization Name'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete
                options={dropdown_vendorname}
                value={
                  dropdown_vendorname.find(
                    option => option === formData.vendorname
                  ) || ''
                }
                onChange={(e, newValue) => handleChange('vendorname', newValue)}
                renderInput={params => (
                  <TextField
                    name='vendorname'
                    {...params}
                    label='Vendor Name'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete
                options={dropdown_vendorid}
                value={
                  dropdown_vendorid.find(
                    option => option === formData.vendorid
                  ) || ''
                }
                onChange={(e, newValue) => handleChange('vendorid', newValue)}
                renderInput={params => (
                  <TextField
                    name='vendorid'
                    {...params}
                    label='Vendor ID'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete
                options={dropdown_vendortype}
                value={
                  dropdown_vendortype.find(
                    option => option === formData.vendortype
                  ) || ''
                }
                onChange={(e, newValue) => handleChange('vendortype', newValue)}
                renderInput={params => (
                  <TextField
                    name='vendortype'
                    {...params}
                    label='Vendor Type'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xl={1}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSearch}
              >
                Search
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button
                style={{ marginLeft: '10px' }}
                variant='contained'
                color='error'
                onClick={handleReset}
              >
                Reset
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button
                style={{ marginLeft: '10px' }}
                variant='contained'
                color='warning'
                onClick={() => props.onBack()}
              >
                Back
              </Button>
            </Grid>
          </Grid>
          {showtable && tableData.length > 0 && (
            <>
              <Typography variant='h6' mt={2} mb={2}>
                Filter
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={1} sm={2} md={2}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      label='Period'
                      value={formData.period}
                      views={['month', 'year']}
                      onChange={newValue => {
                        handleChange('period', newValue)
                      }}
                      renderInput={params => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={1} sm={2} md={2}>
                  <Autocomplete
                    options={['EXTEND', 'ALREADY EXTENDED']}
                    value={formData.state || ''}
                    onChange={(e, newValue) => handleChange('state', newValue)}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label='State'
                        variant='outlined'
                        size='small'
                        fullWidth
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </AccordionDetails>
      </Accordion>
      <br />

      {showtable && tableData.length > 0 ? (
        <>
          <Box align='right'>
            <Button color='success' variant='contained'>
              <CSVLink
                style={{ color: 'white', textDecoration: 'none' }}
                data={tableData}
                filename='VendorPreferences.csv'
              >
                <GetApp />
              </CSVLink>
            </Button>
          </Box>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell>Preferred Vendor ID</TableCell>
                  <TableCell>Vendor Name</TableCell>
                  <TableCell>Member Type</TableCell>
                  <TableCell>GST Treatment</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Vendor Group</TableCell>
                  <TableCell>Extend</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(filteredTableData.length > 0 &&
                  filteredTableData
                    .sort((a, b) =>
                      a['Vendor ID'].localeCompare(b['Vendor ID'])
                    )
                    .map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>
                            <Button
                              variant='text'
                              color='primary'
                              onClick={() => handleScreenRouting(item)}
                              size='sm'
                            >
                              {item['Preferences Vendor ID']}
                            </Button>
                          </TableCell>
                          <TableCell>{item['Vendor Name']}</TableCell>
                          <TableCell>{item['Member Type']}</TableCell>
                          <TableCell>{item['GST Treatment']}</TableCell>
                          <TableCell>{item['Status']}</TableCell>
                          <TableCell>
                            {moment(item['Created At']).format('DD/MM/YYYY')}
                          </TableCell>
                          <TableCell>{item['Vendor Group']}</TableCell>
                          <TableCell>
                            <Button
                              size='sm'
                              onClick={() => handleExtend(item)}
                              disabled={item['Preferences Vendor ID']}
                              variant='contained'
                              color={
                                item['Preferences Vendor ID']
                                  ? 'warning'
                                  : 'success'
                              }
                            >
                              {item['Preferences Vendor ID']
                                ? 'Already Extended'
                                : 'Extend'}
                            </Button>
                          </TableCell>
                        </TableRow>
                      )
                    })) || (
                    <TableRow>
                      <TableCell
                        colSpan={
                          tableData.length > 0 && Object.keys(tableData[0]).length
                        }
                        sx={{ p: 5 }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%'
                          }}
                        >
                          <Alert severity='error' variant='outlined'>
                            No matching records found. Please adjust your search criteria.
                          </Alert>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : null}

      {error ? <div className='center-screen'>{errorMessage}</div> : null}
    </>
  )
}

const mapStateToProps = state => {
  return {
    userData: state.login.userData
  }
}

export default connect(mapStateToProps)(ExtendVendorMaster)